import { gql } from '@apollo/client';
const SET_ORDER_COMPONENT_VARIANT_TO_NOT_READY = gql `
  mutation SetOrderComponentVariantToNotReady($orderComponentVariantId: ID!) {
    setOrderComponentVariantToNotReady(orderComponentVariantId: $orderComponentVariantId) {
      orderComponentVariant {
        id
      }
    }
  }
`;
export default SET_ORDER_COMPONENT_VARIANT_TO_NOT_READY;
